import { Component, Input, OnInit } from "@angular/core";
import { RelatedContentInterface } from "src/app/types/post";

@Component({
  selector: "app-related-content",
  templateUrl: "./related-content.component.html",
  styleUrls: ["./related-content.component.scss"],
})
export class RelatedContentComponent implements OnInit {
  @Input() data: RelatedContentInterface;
  @Input() showType: boolean;
  @Input() hideCategory: boolean = false;

  screenWidth: number;
  screenHeight: number;
  imageSize: number[];

  ngOnInit() {
    this.screenWidth = typeof window !== "undefined" ? window.innerWidth : 1280;
    this.screenHeight =
      typeof window !== "undefined" ? window.innerHeight : 1280;

    if (this.screenWidth >= 1440) {
      this.imageSize = [533, 300];
    } else if (this.screenWidth >= 1280) {
      this.imageSize = [480, 270];
    } else if (this.screenWidth >= 1024) {
      this.imageSize = [427, 240];
    } else if (this.screenWidth >= 768) {
      this.imageSize = [341, 192];
    } else if (this.screenWidth >= 480) {
      this.imageSize = [788, 443];
    } else {
      this.imageSize = [395, 222];
    }
  }
}
